import React from "react";
import { Panel, PanelBody, PanelHeader } from "../../../util/panel";
import TableHardPromotion from "./components/hard-promotion.table";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import { HardPromotionMutateProvider } from "./contexts/hard-promotion.context";
import HardPromotionCriteria from "./components/hard-promotion.criteria";

const HardPromotionList = () => {
  return (
    <HardPromotionMutateProvider>
      <Breadcrumb className="mb-2">
        <Breadcrumb.Item>
          <Link to="/">หน้าหลัก</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>รายการโปรโมชัน</Breadcrumb.Item>
      </Breadcrumb>
      <Panel>
        <PanelHeader>รายการโปรโมชัน</PanelHeader>
        <PanelBody>
          <HardPromotionCriteria />
          <TableHardPromotion />
        </PanelBody>
      </Panel>
    </HardPromotionMutateProvider>
  );
};

export default HardPromotionList;
